import type { NavbarOverviewButtonFragment } from "../client/generated";
import { useNavigate } from "react-router";
import { mdiViewGridOutline } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { NavbarButton } from "../shell/NavbarButton";
import { NavbarButtonIcon } from "../shell/NavbarButtonIcon";
import { routingPaths } from "../navigation/constants";

type Props = {
  fragment: NavbarOverviewButtonFragment;
  disabled?: boolean;
};

export function NavbarOverviewButton({ fragment, disabled }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(routingPaths.document(fragment.id));
  };

  return (
    <NavbarButton tooltip={t("NavbarOverviewButton.tooltip")}>
      <NavbarButtonIcon
        path={mdiViewGridOutline}
        onClick={onClick}
        disabled={disabled}
      />
    </NavbarButton>
  );
}
